import React from 'react'
import { Dimension } from '../types/Dimension'
import { useCtxDimensionName } from '../queries/useCtxDimensionName'

interface DimensionNameProps {
  dimensionId: Dimension['dimensionId']
}

const DimensionName = ({ dimensionId }: DimensionNameProps) => {
  const { data: dimensionName } = useCtxDimensionName({ dimensionId })
  return <span>{dimensionName}</span>
}

export default DimensionName
